import { createQuery } from 'react-query-kit';

import * as BasketTypes from '../api/basket/types.api';
import * as BasketAPI from '../api/basket/index.api';

//
//

const key = 'basket';

//

export const useQueryPreferredBasketGet = createQuery<
  BasketTypes.GetPreferredBasketResponse,
  BasketTypes.GetPreferredBasketQuery
>({
  queryKey: [key, 'preferred'],
  fetcher: (params) => BasketAPI.getPreferredBasketAPI(params),
});

export const useQueryBasketsList = createQuery<
  BasketTypes.GetBasketsResponse,
  BasketTypes.GetBasketsQuery
>({
  queryKey: [key, 'list'],
  fetcher: (params) => BasketAPI.getBasketsAPI(params),
});

export const useQueryBasketByCodeGet = createQuery<
  BasketTypes.GetBasketByCodeResponse,
  BasketTypes.GetBasketByCodeQuery
>({
  queryKey: [key, 'get-by-code'],
  fetcher: (params) => BasketAPI.getBasketByCodeAPI(params),
});
